import { InteractiveContainer } from "@jugl-web/ui-kit";
import React from "react";
import { ReactComponent as TextIcon } from "../../assets/text.svg";
import { AutomationVariableListItem } from "../../types";

type VariableListItemProps = {
  item: AutomationVariableListItem;
  description?: string;
  onClick: (id: string) => void;
};

export const VariableListItem: React.FC<VariableListItemProps> = ({
  item,
  description,
  onClick,
}) => (
  <InteractiveContainer
    className="flex flex-col gap-1 rounded-lg bg-white px-2 py-3"
    onClick={() => onClick(item.id)}
  >
    <div className="flex items-center gap-2">
      <div className="flex h-5 w-5 shrink-0 items-center justify-center rounded bg-primary-50">
        <TextIcon />
      </div>
      <span className="truncate font-secondary text-sm leading-[21px] font-medium text-dark">
        {item.value.label}
      </span>
    </div>
    {description && (
      <span className="jugl__break-word font-secondary text-sm leading-[21px] text-dark-600">
        {description}
      </span>
    )}
  </InteractiveContainer>
);
